<template>
  <div style="width: 100%; height: 500px" class="geo-chart-clinical">
    <div ref="geoChartClinical" style="height: 500px"></div>
  </div>
</template>

<script>
export default {
  name: "GeoChart",
  props: {
    candidates: {
      type: Array,
      default: () => [],
    },
  },
  mounted() {
    this.init();
  },
  methods: {
        init() {
      document.addEventListener("DOMContentLoaded", () => {
        this.loadGoogleCharts();
      });
    },
    loadGoogleCharts() {
      const apiKey = process.env.VUE_APP_GOOGLE_API_KEY;
      // If google is already loaded, draw chart
      if (window.google && window.google.visualization) {
        this.drawChart();
        return;
      }

      // Load script dynamically if not already present
      const scriptId = "googleChartsScript";
      let script = document.getElementById(scriptId);
      if (!script) {
        script = document.createElement("script");
        script.id = scriptId;
        script.src = "https://www.gstatic.com/charts/loader.js";
        script.onload = () => {
          window.google.charts.load("current", {
            packages: ["geochart"],
            mapsApiKey: apiKey,
          });
          window.google.charts.setOnLoadCallback(this.drawChart);
        };
        document.head.appendChild(script);
      } else {
        // If script tag already exists but not loaded yet, wait for it
        script.onload = () => {
          window.google.charts.load("current", { packages: ["geochart"], mapsApiKey: apiKey });
          window.google.charts.setOnLoadCallback(this.drawChart);
        };
      }
    },

    drawChart() {
      if (!window.google || !window.google.visualization || !this.$refs.geoChart) return;

      const data = new window.google.visualization.DataTable();
      data.addColumn("string", "Country");
      data.addColumn("number", "Registered Candidates");

      this.candidates.forEach((item) => {
        data.addRow([item.country, item.count]);
      });

      const options = {
        displayMode: "markers",
        colorAxis: { colors: ["#b1a5d6", "#572ed9"] },
        backgroundColor: "#f5f5f5",
        datalessRegionColor: "#e0e0e0",
        defaultColor: "#f5f5f5",
        width: 1366,
        height: 500,
      };

      const chart = new window.google.visualization.GeoChart(
        this.$refs.geoChartClinical
      );
      chart.draw(data, options);

      window.addEventListener("resize", () => chart.draw(data, options));
    },
  },
  watch: {
candidates: {
    handler() {
      if (window.google && window.google.visualization) {
        this.drawChart();
      }
    },
    deep: true,
  },
  },
};
</script>

<style scoped>
h4 {
  text-align: center;
}
.geo-chart-clinical{
  display: flex;
  align-items: center;
  justify-content: center;
  align-content: center;
  margin: auto;
}
</style>
